export default "__VITE_ASSET__Cc_QB9qA__"